export function replacePatientAttentionId(route: string, patientId: string) {
    return route.replace(":attentionId", patientId);
}